<template>
  <div class="container" style="padding:5px;background:var(--border);border-radius: 5px;">
    <div class="flex-wrap flex-between" style="width:100%;height:30px;font-weight:bold;">
      <div class="flex-wrap"><BaseIcon icon="md-apps" style="margin-right:5px" />
        <div class="flex-wrap">
          <a style="color:var(--primary)">AI - 便捷工具</a>
        </div>
      </div>
      <a @click="RouteToApp"><BaseIcon icon="ios-more" :size="20" /></a>
    </div>
    <div class="flex-wrap align-start" style="width:100%;height:calc(100% - 30px);flex-wrap:wrap;">
      <div class="flex-wrap flex-col flex-center" style="width:70px;height:80px;background:var(--border);border-radius:5px;margin:5px;cursor:pointer" v-for="tool in tools" :key="tool.key" @click="openTool(tool)" >
        <BaseIcon :icon="tool.icon" :size="30" color="var(--bg1)" style="margin-right:5px" />
        <a>{{tool.name}}</a>
      </div>
    </div>
    <Modal transfer v-model="showTool" :width="800" :title="tool.name" footer-hide>
      <div v-if="currentComponent">
        <component :is="currentComponent" />
      </div>
      <div v-else>
        <h3>{{tool.name}}</h3>
        <p>工具开发中，敬请期待...</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import AIPeronsalReport from '@/components/ai/PersonalReport.vue';
export default {
  data() {
    return {
      showTool: false,
      tool: {},
      currentComponent: null,
    };
  },
  components: {
    AIPeronsalReport,
  },
  computed: {
    tools() {
      return [{
        key: 'daily_report',
        name: '岗位报告',
        icon: 'contract',
        url: '/ai/daily_report',
        control: 'AIPeronsalReport',
      }, {
        key: 'project_report',
        name: '项目报告',
        icon: 'contract',
      }, {
        key: 'ppt',
        name: '汇报PPT',
        icon: 'md-mail',
      }];
    },
  },
  methods: {
    openTool(tool) {
      console.log('Opening tool:', tool);
      this.tool = tool;

      // 设置当前组件
      if (tool.control && this.$options.components[tool.control]) {
        this.currentComponent = tool.control;
        console.log('Component found:', tool.control);
      } else {
        this.currentComponent = null;
        console.log('Component not found:', tool.control);
      }

      this.showTool = true;
      console.log('showTool set to:', this.showTool);

      // 强制触发响应式更新
      this.$nextTick(() => {
        console.log('Next tick - showTool:', this.showTool);
      });
    },
    RouteToApp() {
      // 跳转到更多工具页面
      this.$router.push('/core/ai-tools');
    },
  },
};
</script>

<style>

</style>
